import { Typography } from 'antd';

import { ISourceRelation } from 'entities/Offer';
import { JoinedSourceLinks, SourceStatus } from 'entities/Source';
import { getMappedLinks } from 'shared/utils';

export const getJoinedSource = (sourceRelation: ISourceRelation, offer: string, key: number) => {
	const mappedLinks = getMappedLinks(sourceRelation.affiliate_links || []);
	const { status, rejection_comment, source } = sourceRelation;

	return {
		key,
		name: <Typography.Text strong>{source.name}</Typography.Text>,
		status: <SourceStatus sourceStatus={status} />,
		comment: mappedLinks?.length ? (
			<JoinedSourceLinks sourceUuid={source.uuid} offerUuid={offer} count={mappedLinks.length} />
		) : (
			rejection_comment || '-'
		),
	};
};
